import SpinnerSVG from "@/assets/icons/puff.svg?react";

const StorySpinner = () => {
  return (
    <div className="absolute inset-0 flex items-center justify-center z-50">
      <SpinnerSVG />
    </div>
  );
};

export default StorySpinner;
